import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const AddEmoji = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 16 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 16 16"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.5 0C12.7761 0 13 0.223858 13 0.5V3H15.5C15.7761 3 16 3.22386 16 3.5C16 3.77614 15.7761 4 15.5 4H13V6.5C13 6.77614 12.7761 7 12.5 7C12.2239 7 12 6.77614 12 6.5V4H9.5C9.22386 4 9 3.77614 9 3.5C9 3.22386 9.22386 3 9.5 3H12V0.5C12 0.223858 12.2239 0 12.5 0ZM4.50439 8.63976C4.77238 8.57315 5.04362 8.7364 5.11024 9.00439C5.36031 10.0105 6.50187 10.875 8 10.875C9.49813 10.875 10.6397 10.0105 10.8898 9.00439C10.9564 8.7364 11.2276 8.57315 11.4956 8.63976C11.7636 8.70638 11.9268 8.97762 11.8602 9.24561C11.4721 10.807 9.83412 11.875 8 11.875C6.16588 11.875 4.52787 10.807 4.13976 9.24561C4.07315 8.97762 4.2364 8.70638 4.50439 8.63976ZM6.3125 6.875C6.62316 6.875 6.875 6.62316 6.875 6.3125C6.875 6.00184 6.62316 5.75 6.3125 5.75C6.00184 5.75 5.75 6.00184 5.75 6.3125C5.75 6.62316 6.00184 6.875 6.3125 6.875ZM10.25 6.3125C10.25 6.62316 9.9982 6.875 9.68754 6.875C9.37688 6.875 9.12504 6.62316 9.12504 6.3125C9.12504 6.00184 9.37688 5.75 9.68754 5.75C9.9982 5.75 10.25 6.00184 10.25 6.3125ZM7.49996 1.26824C7.77537 1.24807 8 1.47386 8 1.75C8 2.02614 7.77537 2.24773 7.50025 2.27142C4.55862 2.52467 2.25 4.99273 2.25 8C2.25 11.1756 4.82436 13.75 8 13.75C11.0073 13.75 13.4753 11.4414 13.7286 8.49975C13.7523 8.22463 13.9739 8 14.25 8C14.5261 8 14.7519 8.22463 14.7318 8.50004C14.4759 11.9945 11.5597 14.75 8 14.75C4.27208 14.75 1.25 11.7279 1.25 8C1.25 4.44026 4.00554 1.52412 7.49996 1.26824Z"
      />
    </svg>
  )
})

export default AddEmoji
